"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _qrcode = require("qrcode.react");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APQRCode.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var APQRCode = function APQRCode(props) {
  var value = props.value,
    customClass = props.customClass,
    size = props.size;
  var baseClass = 'qr-code';
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
  return /*#__PURE__*/_react["default"].createElement(_qrcode.QRCodeCanvas, {
    value: value,
    size: size,
    className: bemClasses()
  });
};
APQRCode.defaultProps = {
  size: 280,
  customClass: ''
};
APQRCode.protoTypes = {
  size: _propTypes["default"].number,
  customClass: _propTypes["default"].string,
  value: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = APQRCode;